import {Link} from 'react-router-dom' 
const UnauthorizedBlock = ({showReg} : {showReg: boolean}) => {
  const firstOnTheWebSite = <div className="welcome__wrapper">
  <div className="welcome__wrapper__text">
    Впервые на сайте? Пройдите регистрацию
  </div>
  <Link to="/reg" className="welcome__wrapper__link">
    Регистрация
  </Link>
</div>


  return (

    <section className="welcome">
      <div className="container">
          <h1 className="welcome__text">
                Добро пожаловать на сайт тестирования сотрудников аптек "Зерде-Фарма"
          </h1>
          {showReg && firstOnTheWebSite}
      </div>
    </section>
  );
};
export default UnauthorizedBlock;
